import React, { useState, useEffect } from "react";
import { vendor_page_labels } from "../../../Constants/Labels";
import ImagesPreview from "../../ImagesPreview/ImagesPreview";
import RichTextEditor from "../../Global/RichTextEditor/RichTextEditor";
import "./BannerBlock.css";

const BannerBlock = ({
  data,
  onUpdate,
  onRemove,
  bannerBlock,
  bannerBlockImage,
  onChangeBannerBlockField,
  onChangeBannerBlockDescription,
  onOpenBannerImageBlockSelector,
  onRemoveBannerBlockImage,
  config,
  id,
}) => {
  const [localDescription, setLocalDescription] = useState(bannerBlock?.left_content?.description || "");
  const [isUserEditing, setIsUserEditing] = useState(false);

  const handleDescriptionChange = (name, value) => {
    setIsUserEditing(true);
    if (value !== localDescription) {
      setLocalDescription(value);
      onChangeBannerBlockDescription(value);
    }
  };

  useEffect(() => {
    if (!isUserEditing) {
      // console.log("useEffect updating localDescription from props");
      setLocalDescription(bannerBlock?.left_content?.description || "");
    }
  }, [bannerBlock?.left_content?.description, isUserEditing]);

  return (
    <div className="block-container">
      <div className="block-header">
        <h4 className="block-title">{vendor_page_labels?.banner_block?.title}</h4>
        <div className="block-actions">
          <button className="block-action-btn remove" onClick={onRemove}>
            <span className="mdi mdi-delete"></span> Remove
          </button>
        </div>
      </div>
      <div className="card-body">
        <h6 className="mb-3">
          {vendor_page_labels?.banner_block?.left_content?.title}
        </h6>
        <div className="col-lg-10">
          <div className="form-group">
            <label className="form-label">
              {vendor_page_labels?.banner_block?.left_content?.heading}
            </label>
            <input
              type="text"
              className="form-control"
              name="heading"
              value={bannerBlock?.left_content?.heading || ""}
              onChange={(e) => onChangeBannerBlockField(e, 'left_content')}
            />
          </div>
        {/* </div> */}
        {/* <div className="col-lg-10"> */}
          <div className="form-group">
            <label className="form-label">
              {vendor_page_labels?.banner_block?.left_content?.sub_heading}
            </label>
            <input
              type="text"
              className="form-control"
              name="sub_heading"
              value={bannerBlock?.left_content?.sub_heading || ""}
              onChange={(e) => onChangeBannerBlockField(e, 'left_content')}
            />
          </div>
        </div>
        <div className="col-lg-10 mb-4">
          <div className="form-group">
            <label className="form-label">
              {vendor_page_labels?.banner_block?.left_content?.description}
            </label>
            <RichTextEditor
              name="description"
              onChange={handleDescriptionChange}
              value={localDescription}
            />
          </div>
        </div>
        <div className="col-lg-10 row">
          <div className="form-group col-lg-6">
            <label className="form-label">
              {vendor_page_labels?.banner_block?.left_content?.button_label}
            </label>
            <input
              type="text"
              className="form-control"
              name="button_label"
              value={bannerBlock?.left_content?.button_label || ""}
               onChange={(e) => onChangeBannerBlockField(e, 'left_content')}
            />
          </div>
          <div className="form-group col-lg-6">
            <label className="form-label">
              {vendor_page_labels?.banner_block?.left_content?.button_url}
            </label>
            <input
              type="text"
              className="form-control"
              name="button_url"
              value={bannerBlock?.left_content?.button_url || ""}
              onChange={(e) => onChangeBannerBlockField(e, 'left_content')}
            />
          </div>
        </div>
        <h6 className="mb-3">
          {vendor_page_labels?.banner_block?.right_image?.title}
        </h6>
        <div className="col-lg-6">
          <ImagesPreview
            acceptMultipleFiles={false}
            featuredImage={true}
            savedImages={bannerBlockImage && bannerBlockImage.image_id ? [bannerBlockImage] : []}
            userProfile={false}
            style={{ width: "90%" }}
            onOpen={onOpenBannerImageBlockSelector}
            deleteDisable={true}
            selectedImageInfo={bannerBlockImage}
            onRemoveImageIds={onRemoveBannerBlockImage}
          />
        </div>
        {/* <div className="form-group col-lg-6 mt-4">
          <label className="form-label">
            {vendor_page_labels?.banner_block?.right_image?.button_url}
          </label>
          <input
            type="text"
            className="form-control"
            name="img_button_url"
            value={bannerBlock?.right_content?.img_button_url || ""}
            onChange={(e) => onChangeBannerBlockField(e, 'right_content')}
          />
        </div> */}
      </div>
    </div>
  );
};

export default BannerBlock;
